/**
 * Frontend toggle for offbeat/vendor-faq-block.
 *
 * Delegates clicks on .offbeat-faq-q buttons to toggle the .open class on
 * the parent .offbeat-faq-item, which drives the max-height transition.
 */
document.addEventListener( 'click', ( event ) => {
	const button = event.target.closest( '.offbeat-faq-q' );
	if ( ! button ) {
		return;
	}

	const item = button.closest( '.offbeat-faq-item' );
	if ( ! item ) {
		return;
	}

	const isOpen = item.classList.toggle( 'open' );
	button.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
} );
